export const nonReactive = (payload) => JSON.parse(JSON.stringify(payload))

export const clone = (payload) => JSON.parse(JSON.stringify(payload))

export const queryString = {
  stringify: (queryParamsObject) => {
    const queryParamsArray = Object.keys(queryParamsObject).reduce(
      (acc, curr) => [...acc, `${curr}=${queryParamsObject[curr]}`],
      []
    )
    return queryParamsArray.join('&')
  }
}
